import _ from 'lodash';

const getToneDenHeaders = () => {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };

    if (window.tonedenJwt) {
        window.Authorization = `Bearer ${window.tonedenJwt}`;
    }

    if (window.csrfToken) {
        headers['csrf-token'] = window.csrfToken;
    }

    return headers;
};

function handleResponse(callback) {
    return (err, res) => {
        if (!callback) {
            callback = (err) => {
                if (err) {
                    console.error('API error.', err);
                }
            };
        }

        if (res && res.error) {
            if (res.body && res.body.message) {
                var error = new Error(res.body.message);
                error.name = res.body.name || error.name;
                return callback(error);
            } else if (res.body && res.body.error_object) {
                return callback(res.body.error_object);
            } else {
                return callback(res.error);
            }
        } else if (err) {
            return callback(err);
        } else {
            return callback(null, res);
        }
    };
}

export function makeRequest(method, path, params, callback) {
    if (typeof params === 'function') {
        callback = params;
        params = null;
    }

    callback = handleResponse(callback);

    params = _.clone(params);

    _.forIn(params, (value, key) => {
        if (value instanceof Date) {
            params[key] = value.toISOString();
        }
    });

    const requestOptions = {
        method,
        credentials: 'include',
        headers: getToneDenHeaders(),
    };

    if (method === 'get' && params) {
        path += Object.keys(params)
            .map(
                (key) =>
                    `${encodeURIComponent(key)}=${encodeURIComponent(
                        params[key],
                    )}`,
            )
            .join('&');
    } else if (params) {
        requestOptions.body = JSON.stringify(params);
    }

    fetch(path, requestOptions)
        .then((response) => response.json())
        .then((data) => callback(null, data))
        .catch(callback);
}
